import { createElement, useEffect, useRef } from 'react';
import * as echarts from 'echarts';
import axios from 'axios';
const CubeLineChart = function (props) {
    const { url, query = {
        "order": [
            [
                "Deployment.count",
                "desc"
            ],
            [
                "Deployment.createdAt",
                "asc"
            ]
        ],
        "measures": [
            "Deployment.count"
        ],
        "timeDimensions": [
            {
                "dimension": "Deployment.createdAt",
                "granularity": "week"
            }
        ],
        "limit": 5000,
        "dimensions": [
            "Bu.name"
        ]
    } } = props;
    const nodeRef = useRef();
    useEffect(() => {
        axios.request({
            method: 'post',
            url,
            params: {
                app: 'mars',
                env: 'yktest'
            },
            data: {
                query
            }
        }).then(res => {
            console.info(res);
        });
        var myChart = echarts.init(nodeRef.current);
        myChart.setOption({
            title: {
                text: 'ECharts 入门示例'
            },
            tooltip: {},
            xAxis: {
                data: ['衬衫', '羊毛衫', '雪纺衫', '裤子', '高跟鞋', '袜子']
            },
            yAxis: {},
            series: [
                {
                    name: '销量',
                    type: 'bar',
                    data: [5, 20, 36, 10, 10, 20]
                }
            ]
        });
    }, []);
    return createElement("div", { style: { height: 300 }, ref: nodeRef });
};
export default CubeLineChart;
